goog.provide("shadow.js.shim.module$src$svg$objects$magic_wand_svg$default");
shadow.js.shim.module$src$svg$objects$magic_wand_svg$default = shadow.js.shim.module$src$svg$objects$magic_wand_svg.default;
